// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app.landing-page {\n  height: 100dvh;\n  position: relative;\n}\n#app.landing-page .main-content {\n  max-height: none;\n}\n#app.landing-page .landing-page-header {\n  pointer-events: none;\n}\n#app.landing-page .landing-page-header .language-container {\n  pointer-events: all;\n}", ""]);
// Exports
module.exports = exports;
